/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Advanced_Options_TitleInputs */



/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {Audio_Description_Export_Advanced_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_advanced_options_title = /** @type {((inputs?: Audio_Description_Export_Advanced_Options_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Advanced_Options_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options avancées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erweiterte Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni avanzate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширенные параметры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones avanzadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("高级选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("詳細オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन्नत विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções avançadas")
	return /** @type {LocalizedString} */ ("Advanced Options")
});